import autoBind from 'react-autobind/src/autoBind';
import TableHelper from 'src/utils/table-helper';
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import composeModalActions from 'src/utils/modal-action-wrapper';
import { List, ListItem, makeSelectable } from 'material-ui/List';
import ArrowBack from 'material-ui/svg-icons/navigation/arrow-back';
import { blue700, green700, red400 } from 'material-ui/styles/colors';
import moment from 'moment';
import { asyncRequest, Entities, TOMCAT_URL } from 'src/common';
import BootstrapTableErrorBoundary from 'src/components/error/BootstrapTableErrorBoundary';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { FilterToggle } from 'src/components/admin/buslocations/filter-toggle';
import DatePicker from 'material-ui/DatePicker';
import OpenFolderIcon from 'material-ui/svg-icons/file/folder-open';
import ClosedFolderIcon from 'material-ui/svg-icons/file/folder';
import LabelIcon from 'material-ui/svg-icons/action/label';
import CircularProgress from 'material-ui/CircularProgress';

let SelectableList = makeSelectable(List);

class FindMyBusOperator extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.tableHelper = new TableHelper({
            onRowClick: this.onRowClick,
            pageSize: 100,
        });
        this.state = {
            startedFetching: false,
            fromDate: moment().startOf('month').toDate(),
            toDate: moment().toDate(),
            filterOnlyNoOffers: false,
        };
    }

    componentWillMount() {
        this.props.fetchCompanyOwnedBookingIntegrations();
        this.fetchFindMyBusRequests();
    }

    componentWillReceiveProps(nextProps, nextContext) {
        const { findMyBusRequests, integration } = nextProps;
        if (!this.state.startedFetching && findMyBusRequests.isFetching) this.setState({ startedFetching: true });

        const finishedFetching = this.state.startedFetching && !findMyBusRequests.isFetching && !integration.isFetching;
        if (finishedFetching) {
            const hasSpecificCompanyAccess = integration.items.some(item => item.allCompanies === false);
            if (!hasSpecificCompanyAccess) this.props.router.push('offer-administration');
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            this.tableHelper.processPaginationAfterUpdate(
                prevProps.findMyBusRequests,
                this.props.findMyBusRequests,
                this.table,
            )
        )
            this.setState({ renderSelection: !this.state.renderSelection });

        if (
            prevState.fromDate !== this.state.fromDate ||
            prevState.toDate !== this.state.toDate ||
            prevState.filterOnlyNoOffers !== this.state.filterOnlyNoOffers
        ) {
            this.fetchFindMyBusRequests();
        }
    }

    createActiveFilterForQuery() {
        const queryParams = [];
        if (this.state.fromDate && this.state.toDate) {
            queryParams.push(`fromDate=${moment(this.state.fromDate).format('YYYY-MM-DD')}`);
            queryParams.push(`toDate=${moment(this.state.toDate).format('YYYY-MM-DD')}`);
        }
        queryParams.push(`filterNoOffer=${this.state.filterOnlyNoOffers}`);

        return queryParams.join('&');
    }

    fetchFindMyBusRequests() {
        this.props.search(
            Entities.FIND_MY_BUS_REQUEST,
            `get-find-my-bus-requests?${this.createActiveFilterForQuery()}`,
            0,
            undefined,
            true,
            () => {
                this.setState({ startedFetching: false });
            },
        );
    }

    createCustomToolBar(toolbarProps) {
        const { t } = this.props;

        return (
            <>
                <div className="row">
                    <div className="col-md-12" style={{ display: 'flex', gap: 20, alignItems: 'flex-end' }}>
                        <div>
                            <FilterToggle
                                label={t('find_my_bus.no_offer_created')}
                                labelStyle={{
                                    width: '250px',
                                    fontSize: '10px',
                                }}
                                toggled={this.state.filterOnlyNoOffers}
                                onToggle={() => this.setState({ filterOnlyNoOffers: !this.state.filterOnlyNoOffers })}
                            />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div style={{ display: 'flex', gap: 20, alignItems: 'center' }}>
                            <div>
                                <DatePicker
                                    value={this.state.fromDate}
                                    container="inline"
                                    disabled={this.startedFetching || this.state.noDate}
                                    formatDate={date => moment(date).format('DD.MM.YYYY')}
                                    floatingLabelText={t('search_requests.from.title')}
                                    onChange={(_event, value) => this.setState({ fromDate: value })}
                                    maxDate={this.state.toDate}
                                    autoOk={true}
                                    textFieldStyle={{ width: 130, marginLeft: 7 }}
                                />
                            </div>
                            <div>
                                <DatePicker
                                    value={this.state.toDate}
                                    container="inline"
                                    disabled={this.startedFetching || this.state.noDate}
                                    formatDate={date => moment(date).format('DD.MM.YYYY')}
                                    floatingLabelText={t('search_requests.to.title')}
                                    onChange={(_event, value) => this.setState({ toDate: value })}
                                    minDate={this.state.fromDate}
                                    autoOk={true}
                                    textFieldStyle={{ width: 130, marginLeft: 30 }}
                                />
                            </div>
                            <div
                                style={{
                                    width: 400,
                                    marginRight: 6,
                                    marginTop: 34,
                                    marginLeft: 'auto',
                                }}>
                                {toolbarProps.components.searchPanel}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    tableActionsFormatter(_cell, request) {
        const { t } = this.props;
        return (
            <div>
                <button
                    type="button"
                    className="btn btn-xs transparent"
                    title={t('user_functionality.create_offer')}
                    onClick={() => {
                        asyncRequest(
                            `${TOMCAT_URL}api/${Entities.FIND_MY_BUS_REQUEST.repository}/create-link-for-offer/${request.id}`,
                        )
                            .then(response => {
                                const json = response.json;
                                if (json && json.url) {
                                    const win = window.open(json.url, '_blank');
                                    if (win != null) win.focus();
                                }
                            })
                            .catch(error => console.error('Error creating Link', error));
                    }}>
                    <span className="glyphicon glyphicon-new-window text-info" />
                </button>
            </div>
        );
    }

    requestStatus(request) {
        const { t } = this.props;
        if (request == null || request.offerDetails == null)
            return (
                <span title={t('bus_requests.filter.offer_missing')}>
                    <OpenFolderIcon color={red400} />
                </span>
            );
        if (request.offerDetails.offerStatus === 'OPEN')
            return (
                <span title={t('bus_requests.filter.offer_created')}>
                    <ClosedFolderIcon color={blue700} />
                </span>
            );
        if (request.offerDetails.offerStatus === 'ACCEPTED')
            return (
                <span title={t('bus_requests.filter.customer_booked')}>
                    <LabelIcon color={green700} />
                </span>
            );
    }

    render() {
        const { t, findMyBusRequests, integration } = this.props;
        const tableData = [];

        const finishFetching = this.state.startedFetching && !findMyBusRequests.isFetching && !integration.isFetching;

        if (!finishFetching) return <CircularProgress />;

        if (!findMyBusRequests.isFetching && findMyBusRequests.items.length > 0) {
            findMyBusRequests.items.map(request => {
                tableData.push({
                    id: request.id,
                    createdAt: moment(request.createdAt).utc().format('DD.MM.YYYY HH:mm:ss'),
                    bookingIntegrationId: request.bookingIntegrationId,
                    email: request.customerContactData != null ? request.customerContactData.email : null,
                    taskFrom: request.taskFrom,
                    fromTime: moment(request.taskFromTime).format('DD.MM.YYYY HH:mm'),
                    taskTo: request.taskTo,
                    requestState: request.searchResults,
                    journeyId: request.journeyId,
                    note: request.note,
                    entity: request,
                    booking: request.booking,
                });
            });
        }
        return (
            <>
                <div className="col-md-2 sidebar-listview">
                    <SelectableList
                        selectedItemStyle={{
                            backgroundColor: '#0a71ba1a',
                        }}
                        value={1}
                        onChange={() => this}>
                        <ListItem
                            className="styled-list-item"
                            key={2}
                            primaryText={t('offers.back_to_offers')}
                            leftIcon={<ArrowBack color={blue700} />}
                            onClick={() => this.props.push('/offer-administration')}
                        />
                    </SelectableList>
                </div>
                <div className="col-md-10">
                    <legend className="legend">{t('find_my_bus.title')}</legend>
                    <BootstrapTableErrorBoundary>
                        <BootstrapTable
                            ref={ref => (this.table = ref)}
                            data={tableData}
                            striped={true}
                            hover={true}
                            exportCSV={true}
                            condensed={true}
                            pagination={true}
                            options={Object.assign(
                                { toolBar: this.createCustomToolBar },
                                this.tableHelper.getOptions(finishFetching),
                            )}
                            selectRow={Object.assign({}, this.tableHelper.getRowProps())}
                            searchPlaceholder={t('common_phrases.search')}
                            search={true}>
                            <TableHeaderColumn
                                columnTitle={true}
                                dataField="id"
                                hidden={true}
                                isKey={true}
                                export={true}>
                                ID
                            </TableHeaderColumn>
                            <TableHeaderColumn columnTitle={true} width="80" dataField="createdAt" dataSort={true}>
                                {t('find_my_bus.requested')}
                            </TableHeaderColumn>
                            <TableHeaderColumn width="100" dataField="email" dataSort={true}>
                                {t('search_requests.email')}
                            </TableHeaderColumn>
                            <TableHeaderColumn columnTitle={true} width="80" dataField="fromTime" dataSort={true}>
                                {t('search_requests.from.time')}
                            </TableHeaderColumn>
                            <TableHeaderColumn columnTitle={true} width="140" dataField="taskFrom" dataSort={true}>
                                {t('search_requests.from.location')}
                            </TableHeaderColumn>
                            <TableHeaderColumn columnTitle={true} width="140" dataField="taskTo" dataSort={true}>
                                {t('search_requests.to.location')}
                            </TableHeaderColumn>

                            <TableHeaderColumn columnTitle={true} width="140" dataField="note" dataSort={true}>
                                {t('find_my_bus.customer_note')}
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                columnTitle={true}
                                dataField="booking"
                                width="40"
                                dataFormat={this.requestStatus}
                                csvFormat={this.requestStatus}>
                                Status
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                dataField="actions"
                                width="60"
                                dataFormat={this.tableActionsFormatter}
                                export={false}>
                                {t('common_phrases.actions')}
                            </TableHeaderColumn>
                        </BootstrapTable>
                    </BootstrapTableErrorBoundary>
                </div>
            </>
        );
    }
}

export default withTranslation()(composeModalActions(FindMyBusOperator));
